// tslint:disable:curly

import { Injectable } from '@angular/core';
import { Tag } from './tag';
import { DbRecord } from './db-record';
import { RatingService } from './rating.service';
import { FileService } from './file.service';
import { RTagGroupService } from './r-tag-group.service';

@Injectable()
export class FilterService {
  searchFilter: RegExp;
  fromYearFilter: number;
  toYearFilter: number;
  tagFilters = new Set<Tag>();
  tagExcludeFilters = new Set<Tag>();
  ratingTagFilters = new Set<string>();
  ratingTagExcludeFilters = new Set<string>();
  ratingFilterCode = '';

  constructor(
    private rs: RatingService,
    private files: FileService,
    private rtgs: RTagGroupService
  ) { }

  run(ls: DbRecord[]) {
    ls = this.rs.filter(ls);
    if (this.ratingFilterCode) {
      ls = ls.filter(x => x.hasRatingCode(this.ratingFilterCode));
    }
    if (this.tagFilters.size)
      ls = ls.filter((x) => x.hasTags(this.tagFilters));
    if (this.tagExcludeFilters.size)
      ls = ls.filter((x) => x.excludeTags(this.tagExcludeFilters));
    if (this.ratingTagFilters.size) {
      ls = ls.filter((x) => {
        const tmp = Array.from(this.ratingTagFilters);
        for (let i = 0; i < tmp.length; i++) {
          if (!this.rtgs.hasRTag(x, tmp[i])) {
            return false;
          }
        }
        return true;
      });
    }

    if (this.ratingTagExcludeFilters.size) {
      ls = ls.filter((x) => {
        const tmp = Array.from(this.ratingTagExcludeFilters);
        for (let i = 0; i < tmp.length; i++) {
          if (this.rtgs.hasRTag(x, tmp[i])) {
            return false;
          }
        }
        return true;
      });
    }


    if (this.searchFilter)
      ls = ls.filter((x) => x.regexpHit(this.searchFilter));

    if (this.fromYearFilter || this.toYearFilter)
      ls = ls.filter((x) =>
        x.yearHit(this.fromYearFilter, this.toYearFilter));

    if (this.files.isFilterOn('recordsWith')) {
      ls = ls.filter(x => this.files.filesMap.has(x.id));
    };

    if (this.files.isFilterOn('recordsWithout')) {
      ls = ls.filter(x => !this.files.filesMap.has(x.id));
    };



    return ls;
  }

  highlightSearchHits(txt: string) {
    if (!this.searchFilter || !txt)
      return txt;
    return txt.replace(this.searchFilter, '<span class="searchHit">$&</span>');
  }

  setTagFilter(tag: Tag) {
    if (!this.tagFilters.delete(tag)) {
      this.tagFilters.add(tag);
      this.tagExcludeFilters.delete(tag);
    }
  }

  isSelectedTag(tag: Tag) {
    return this.tagFilters.has(tag);
  }

  setExcludeTagFilter(tag: Tag) {
    if (!this.tagExcludeFilters.delete(tag)) {
      this.tagExcludeFilters.add(tag);
      this.tagFilters.delete(tag);
    }
  }

  isExcludedTag(tag: Tag) {
    return this.tagExcludeFilters.has(tag);
  }

  setRatingTagFilter(tag: string, extraDeleteLs?: string[]) {
    if (!this.ratingTagFilters.delete(tag)) {
      this.ratingTagFilters.add(tag);
      this.ratingTagExcludeFilters.delete(tag);
      return;
    };

    if (extraDeleteLs) {
      extraDeleteLs.forEach(x => this.ratingTagFilters.delete(x));
    }
  }

  isSelectedRatingTag(tag: string) {
    return this.ratingTagFilters.has(tag);
  }

  setExcludeRatingTagFilter(tag: string, extraDeleteLs?: string[]) {
    if (!this.ratingTagExcludeFilters.delete(tag)) {
      this.ratingTagExcludeFilters.add(tag);
      this.ratingTagFilters.delete(tag);
      return;
    }

    if (extraDeleteLs) {
      extraDeleteLs.forEach(x => this.ratingTagExcludeFilters.delete(x));
    }
  }

  isExcludedRatingTag(tag: string) {
    return this.ratingTagExcludeFilters.has(tag);
  }

  clear() {
    this.searchFilter = null;
    this.tagFilters.clear();
    this.tagExcludeFilters.clear();
    this.ratingTagFilters.clear();
    this.ratingTagExcludeFilters.clear();
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/filter.service.ts